<template>
  <div>
    <LoadingIndicator :loading="!processCompleted" />
    <OnexAlert v-if="isShowMessage" :type="Notifications.warning" :icon="mdiAlert">
      {{
        $t('L_please_be_advised_that_an_immediate_withdrawal_of', {
          amount: getImmediatePayAmount,
        })
      }}
      <template #description>
        <v-row wrap>
          <v-col cols="12">
            <ul class="payment-alert-list">
              <li v-if="showFirstMessage">
                {{ $t('L_you_have_an_outstanding_past_due') }}
              </li>
              <li v-if="showSecondMessage">
                {{ $t('L_you_have_selected_a_withdrawal_day') }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </template>
    </OnexAlert>
    <div class="mt-4 pb-4" :class="$vuetify.display.xs ? 'pl-8' : 'px-8'">
      <v-row wrap class="mb-4 pb-4 mt-4">
        <v-col cols="12">
          <div>
            <v-row wrap>
              <v-col>
                <h4>
                  {{ $t('L_please_review_and_confirm_your_updated_billing_information_below') }}
                </h4>
              </v-col>
            </v-row>
            <v-row wrap class="mt-4" v-if="isDirectBill">
              <v-col cols="12" class="px-6">
                <v-row wrap class="bluebox pl-2 pr-2 mb-4">
                  <v-col xs="6" class="font-size--14 mt-4">
                    {{ $t('L_billing_method') }}
                  </v-col>
                  <v-col
                    xs="6"
                    class="mt-2 pr-0 mr-4 text-right"
                    :class="$vuetify.display.xs ? 'mt-4' : ''"
                  >
                    <OnexButton @click="goToPageOne">
                      <span class="font-size--12">{{ $t('L_change') }}</span>
                    </OnexButton>
                  </v-col>
                  <v-col cols="12" class="font-size--16 font-weight-bold pa-0 pl-3">
                    {{ frequencyType }}
                  </v-col>
                  <v-col cols="12" class="mt-4 font-size-14">
                    {{ $t('L_payment_amount') }}
                  </v-col>
                  <v-col cols="12" class="mb-4 font-size--16 font-weight-bold pa-0 pl-3">
                    {{ getPaymentAmount }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row wrap class="mt-4" v-else>
              <v-col cols="12" class="px-6">
                <!-- Billing Method -->
                <v-row class="bluebox pl-2 pr-2 mb-4">
                  <v-col xs="6" class="font-size--14 mt-4 pb-0">
                    {{ $t('L_billing_method') }}
                  </v-col>
                  <v-col
                    xs="6"
                    class="mt-2 pr-0 mr-4 text-right pb-0"
                    :class="$vuetify.display.xs ? 'mt-4' : ''"
                  >
                    <OnexButton @click="goToPageOne">
                      <span class="font-size--12">{{ $t('L_change') }}</span>
                    </OnexButton>
                  </v-col>
                  <v-col cols="12" class="font-size--16 font-weight-bold pt-0">
                    {{ frequencyType }}
                  </v-col>
                  <v-col cols="12" class="mt-4 font-size--14 pb-0">
                    {{ $t('L_payment_amount') }}
                  </v-col>
                  <v-col cols="12" class="mt-2 font-size--16 font-weight-bold pt-0">
                    {{ getPaymentAmount }}
                  </v-col>
                </v-row>

                <!-- Payment Withdrawal Day -->
                <v-row class="bluebox pl-2 pr-2 mb-4">
                  <v-col xs6 class="font-size--14 mt-4 pb-0">
                    {{ $t('L_payment_withdrawal_date') }}
                  </v-col>
                  <v-col xs6 class="mt-2 pr-0 mr-4 text-right pb-0">
                    <OnexButton @click="goToPageThree">
                      <span class="font-size--12">{{ $t('L_change') }}</span>
                    </OnexButton>
                  </v-col>
                  <v-col cols="12" class="font-size--16 font-weight-bold pt-0">
                    {{ getPaymentWithdrawalDay }}
                  </v-col>
                </v-row>

                <!-- Bank Account -->
                <v-row class="bluebox pl-2 pr-2 mb-4">
                  <v-col xs="6" class="font-size--14 mt-4 pb-0">
                    {{ $t('L_bank_account') }}
                  </v-col>
                  <v-col xs="6" class="mt-2 pr-0 mr-4 text-right pb-0">
                    <OnexButton @click="goToPageTwo">
                      <span class="font-size--12">{{ $t('L_change') }}</span>
                    </OnexButton>
                  </v-col>
                  <v-col cols="12" class="font-size--16 font-weight-bold pt-0 pb-0">
                    {{ getMaskedAcctNumberWAcctType }}
                  </v-col>
                  <v-col cols="12" class="mt-2 mb-4 font-size--14 font-weight-regular pt-0">
                    {{ getBankName }}
                  </v-col>
                </v-row>

                <v-row wrap>
                  <v-col cols="12" class="px-0">
                    <v-card class="setMaxHeightCard mt-4 mb-8" :rounded="false">
                      <v-card-text>
                        <v-row wrap mt-4>
                          <v-col cols="12" class="font-weight-bold font-size--16 mb-4">
                            <span v-html="disclaimerTitle" />
                          </v-col>
                          <v-col cols="12" class="font-weight-regular font-size--14 mb-8">
                            <span v-html="disclaimerBody" />
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row wrap>
                  <v-col cols="12" class="px-0">
                    <v-checkbox
                      v-model="accepted"
                      :label="$t('L_by_checking_the_box_and_clicking_I_authorize')"
                      color="primary"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <div class="mb-4">
        <v-row class="d-flex justify-end my-4">
          <v-col cols="12" sm="4" md="3" class="px-4">
            <OnexButton block variant="outlined" color="outlined" @click="cancelPayment">
              {{ $t('L_cancel') }}
            </OnexButton>
          </v-col>
          <v-col cols="12" sm="4" md="3" class="px-4">
            <OnexButton
              v-if="isDirectBill"
              block
              :disabled="!processCompleted"
              @click="goToStepFiveDirectBill"
            >
              {{ $t('L_confirm') }}
            </OnexButton>
            <OnexButton
              v-else
              block
              :disabled="!accepted || !processCompleted"
              @click="goToStepFiveBankDraft"
            >
              {{ $t('L_i_authorize') }}
            </OnexButton>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState, mapActions } from 'pinia';
import { currency } from '@/shared/util/formatters';
import MessageDialog from '../../../../../components/MessageDialog.vue';
import LoadingIndicator from '../../../../../components/LoadingIndicator.vue';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import type { AxiosResponse } from 'axios';
import { Notifications, OnexAlert, OnexButton } from '@primerica/onex-ui-lib';
import { mdiAlert } from '@mdi/js';
import type { IPolicyStorePolicy } from '@/modules/policy/store/policyStore.model';

const componentOptions: ComponentOptions = {
  name: 'BankAccountTypeChangeStepFour',
  components: {
    MessageDialog,
    LoadingIndicator,
    OnexAlert,
    OnexButton,
  },
  data: () => ({
    accepted: false,
    processCompleted: true,
    Notifications,
    mdiAlert,
  }),
  props: {
    selectedOption: {
      type: String,
      required: false,
      default: '-1',
    },
    bankInfo: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    paymentAmount: {
      type: String,
      required: true,
      default: '',
    },
    wDay: {
      type: String,
      required: false,
      default: '',
    },
    nextPaymentDueDate: {
      type: String,
      required: false,
      default: '',
    },
    propIsPaidToDateInFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    propIsPastDue: {
      type: Boolean,
      required: false,
      default: false,
    },
    propIsUserSelDateEarlierThanTwoDaysFromNow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      dateFormat: 'getDateFormat',
    }),
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(usePolicyStore, {
      policies: 'policies',
      paymentData: 'paymentData',
      policyData: 'currentPolicy',
      showPayNowButton: 'showPayNow',
      paymentInfoShowPaymentAmountDateBillingMethod:
        'paymentInfoShowPaymentAmountDateBillingMethod', // TODO: access state directly
    }),
    getPaymentAmount() {
      return currency(+this.paymentAmount, 2);
    },
    showFirstMessage() {
      const isPastDue = this.policyData?.paynowInfo?.isPastDue || false;
      if (isPastDue === true) {
        return true;
      }
      return false;
    },
    showSecondMessage() {
      const isPastDue = this.policyData?.paynowInfo?.isPastDue || false;
      if (
        isPastDue === false &&
        this.propIsPaidToDateInFuture === false &&
        this.propIsUserSelDateEarlierThanTwoDaysFromNow
      ) {
        return true;
      } else if (isPastDue === true && this.propIsUserSelDateEarlierThanTwoDaysFromNow) {
        return true;
      }
      return false;
    },
    getImmediatePayAmount() {
      const isPastDue = this.policyData?.paynowInfo?.isPastDue || false;
      if (
        isPastDue === false &&
        this.propIsPaidToDateInFuture === false &&
        this.propIsUserSelDateEarlierThanTwoDaysFromNow
      ) {
        return `$${this.policyData?.paymentInfo?.PACPremium}`;
      } else if (isPastDue === true && this.propIsUserSelDateEarlierThanTwoDaysFromNow) {
        return `$${this.policyData?.paynowInfo?.pastDueAmountPlusPac}`;
      } else if (isPastDue === true && !this.propIsUserSelDateEarlierThanTwoDaysFromNow) {
        return `$${this.policyData?.paynowInfo?.pastDueAmount}`;
      }
      return '';
    },
    isCanadaPolicy() {
      return !!this.policyData?.isCanadaPolicy;
    },
    disclaimerTitle() {
      return this.isCanadaPolicy
        ? this.$t('L_change_billing_method_disclaimer_title_ca')
        : this.$t('L_change_billing_method_disclaimer_title_us');
    },
    disclaimerBody() {
      return this.isCanadaPolicy
        ? this.$t('L_change_billing_method_disclaimer_body_ca')
        : this.$t('L_change_billing_method_disclaimer_body_us');
    },
    // Check the logic for withdrawal day 2 day 3 days
    getBillingMethod() {
      if (this.selectedOption === '1bd') {
        return this.$t('1bd');
      } else if (this.selectedOption === '1db') {
        return this.$t('1db');
      } else if (this.selectedOption === '3db') {
        return this.$t('3db');
      } else if (this.selectedOption === '6db') {
        return this.$t('6db');
      } else if (this.selectedOption === '12db') {
        return this.$t('12db');
      } else {
        return '';
      }
    },
    getPaymentWithdrawalDay() {
      const value = `${this.bankInfo?.draftDay}`;
      let num;
      const val = value.startsWith('0') ? value.slice(1) : value;
      switch (val) {
        case '1':
        case '21':
          num = 'st';
          break;
        case '2':
        case '22':
          num = 'nd';
          break;
        case '3':
        case '23':
          num = 'rd';
          break;
        default:
          num = 'th';
      }
      const datetext = `${val}${num}`;
      return this.$t('L_date_of_each_month', { day: datetext });
    },
    getMaskedAcctNumberWAcctType() {
      const value = this.bankInfo?.accountNumber || '';
      return `${value.substring(0, value.length - 4).replace(/\d/g, '')}****${value.substring(
        value.length - 4
      )} ${this.bankInfo?.accountTypeString}`;
    },
    getBankName() {
      return this.bankInfo?.bankName || '';
    },
    isPastDueAndOnDirectBill() {
      // remove the negation
      // ? see policy/details/components/PaymentInformation/components/ChangePaymentMethod/components/EditPaymentMethod/StepTwo/StepTwo.vue
      // ? UpdateBank Component is used when changing to ACH, so it is implied that user is changing to ACH here
      const isDirectBill = this.policyData?.isA1BillingForm; // Client is past due and is currently on Direct Bill
      // const paidToDate = this.policyData?.paymentInfo?.paidToDate;
      // const todayUTC = toUTCDate(new Date());
      // const paidDateUTC = toUTCDate(paidToDate);
      // const isPaidToDateBeforeToday = isBefore(paidDateUTC, todayUTC);
      // const isPaidToDateToday = isSameDay(paidDateUTC, todayUTC);
      const isPaidToDateBeforeToday = this.policyData?.paynowInfo?.isPastDue;
      return isDirectBill && isPaidToDateBeforeToday; // verify with business
    },
    isDirectBill() {
      if (this.selectedOption !== '1bd') {
        return true;
      }
      return false;
    },
    frequencyType() {
      if (this.selectedOption === '1bd') {
        return `${this.$t('L_every_month_by_automatic_bank_withdrawal')} ${this.$t(
          'L_every_month'
        )}`;
      } else if (this.selectedOption === '1db') {
        return `${this.$t('L_monthly_direct_bill')} ${this.$t('L_every_month')}`;
      } else if (this.selectedOption === '3db') {
        return `${this.$t('L_every_three_months')} ${this.$t('L_every_three_months_sub')}`;
      } else if (this.selectedOption === '6db') {
        return `${this.$t('L_every_six_months')} ${this.$t('L_every_six_months_sub')}`;
      } else if (this.selectedOption === '12db') {
        return `${this.$t('L_once_a_year')} ${this.$t('L_once_a_year_sub')}`;
      }
      return '';
    },
    reqMode() {
      if (this.selectedOption === '1db') {
        return '01';
      } else if (this.selectedOption === '3db') {
        return '03';
      } else if (this.selectedOption === '6db') {
        return '06';
      } else if (this.selectedOption === '12db') {
        return '12';
      }
      return '';
    },
    paymentDueDate() {
      return this.policyData?.data?.nextPaymentDueDate || '';
    },
    payInProgress() {
      return this.policy?.paymentInfo?.PayInProcess === '1';
    },
    kubraPaymentInProgress() {
      // return this.policy?.kubraPaymentStatus !== null;
      return !!this.policy?.kubraPaymentStatus;
    },
    showPayInProgressBanner() {
      return this.payInProgress || this.kubraPaymentInProgress;
    },
    currentDirectBillMonthly() {
      if (
        this.policyData?.paymentInfo?.billMode === '01' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillQuarterly() {
      if (
        this.policyData?.paymentInfo?.billMode === '03' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillSemiAnnual() {
      if (
        this.policyData?.paymentInfo?.billMode === '06' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillAnnual() {
      if (
        this.policyData?.paymentInfo?.billMode === '12' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentBankDraftMonthly() {
      if (this.policyData?.paymentInfo?.billForm.toLowerCase() === 'b2') {
        return true;
      }
      return false;
    },
    getMonthlyAmount() {
      return this.policyData?.paymentInfo?.newPremiumAmount || '';
    },
    getQuarterlyDirectBillAmount() {
      return this.policyData?.paymentInfo?.quarterlyPremium || '';
    },
    getSemiAnnualDirectBillAmount() {
      return this.policyData?.paymentInfo?.semiAnnualPremium || '';
    },
    getAnnualDirectBillAmount() {
      return this.policyData?.paymentInfo?.annualPremium || '';
    },
    isShowMessage() {
      const isPastDue = this.policyData?.paynowInfo?.isPastDue || false;
      if (
        isPastDue === false &&
        this.propIsPaidToDateInFuture === false &&
        this.propIsUserSelDateEarlierThanTwoDaysFromNow
      ) {
        return true;
      } else if (isPastDue === true) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
    ...mapActions(usePolicyStore, {
      getPolicies: 'getPolicies',
      getPaymentInfo: 'getPaymentInfo',
      updateBillingMode: 'updateBillingMode',
      changePolicy: 'changePolicy',
    }),
    goToPageOne() {
      this.$emit('pageOne');
    },
    goToPageTwo() {
      this.$emit('pageTwo');
    },
    goToPageThree() {
      this.$emit('pageThree');
    },
    async refreshPolicies() {
      return await this.getPolicies();
    },
    async refreshPaymentData() {
      await this.getPaymentInfo(this.policyData?.contractId);
      this.$emit('pageFive');
    },
    async goToStepFiveDirectBill() {
      try {
        if (this.processCompleted === false) {
          return;
        }
        this.processCompleted = false;
        // Send the data for the payment amount and payment due date
        this.$emit('showFirstMessage', this.showFirstMessage);
        this.$emit('showSecondMessage', this.showSecondMessage);
        this.$emit('isShowMessage', this.isShowMessage);
        this.$emit('immediatePayAmount', this.getImmediatePayAmount);
        this.$emit('paymentDueDate', this.paymentDueDate);
        this.$emit('isPastDueAndOnDirectBill', this.isPastDueAndOnDirectBill);
        // Start
        try {
          const i = this.$dynatrace.enterAction(
            `UpdateBillingMethod_${this.$t('L_monthly_bank_draft')?.replaceAll(
              ' ',
              '-'
            )}_ConfirmChange_selected`
          );
          this.$dynatrace.leaveAction(i);
        } catch (_error) {
          /* empty */
        } finally {
          /* empty */
        }
        const payAmount = parseFloat(this.paymentAmount).toFixed(2) + ''; // .replace('$', '');
        const paymentInfo = {
          type: 'METHOD',
          draftAmount: payAmount,
          draftDay: this.policyData?.paymentInfo?.AutoDraftPaymentDate,
          emailAddress: this.customerProfile.email,
          language: this.locale,
          nextCycleDate: this.policyData?.paymentInfo?.NextCycleDate,
          reqMode: this.reqMode,
        };
        const resp = await this.updateBillingMode({
          paymentInfo,
          policyNumber: this.policyData?.contractId,
        });
        if (resp) {
          // TODO
          // try {
          //   const i = this.$dynatrace.enterAction(`UpdateBillingMethod_${this.$t('L_monthly_bank_draft')?.replaceAll(' ', '-')}_ChangesSubmitted_Success`);
          //   this.$dynatrace.leaveAction(i);
          // } catch (error) { /*  */ }
          /*
           * Emit a custom action when a user successfully submits a bank/payment info change
           * https://www7.v1host.com/Primerica/attachment.img/284635/Analytics%20User%20Stories%20DT_3.30.21.docx
           */
          // TODO
          // const m = 'bank_info_changes_saved';
          // const i = this.$dynatrace.enterAction(m);
          // this.$dynatrace.leaveAction(i);

          // TODO see if following 2 is needed
          // this.$emit('goToStepThree', this.bankInfo);
          // this.showCompleteBanner();
          // This is to ensure that policy doesn't change to a different one.
          const currentContractId = this.policyData?.contractId;
          await this.refreshPolicies();
          // Find the index that has the same contractId and use it to set the policyData
          const index = this.policies.findIndex(
            (policy: IPolicyStorePolicy) => policy.contractId === currentContractId
          );
          await this.changePolicy({ selectedIndex: index });
          // if (resStatus === 200) {
          await this.refreshPaymentData();
        } else {
          this.showErrorBanner();
          try {
            const i = this.$dynatrace.enterAction(
              `UpdateBillingMethod_${this.$t('L_monthly_bank_draft')?.replaceAll(
                ' ',
                '-'
              )}_ChangesSubmitted_Failure_updateBillingModeError`
            );
            this.$dynatrace.leaveAction(i);
          } catch (_error) {
            /* empty */
          }
        }
        this.processCompleted = true;
      } catch (_error) {
        /* empty */
      } finally {
        this.paymentInfoShowPaymentAmountDateBillingMethod = true;
      } // End
    },
    async goToStepFiveBankDraft() {
      try {
        if (this.processCompleted === false) {
          return;
        }
        this.processCompleted = false;
        // Send the data for the payment amount and payment due date
        this.$emit('showFirstMessage', this.showFirstMessage);
        this.$emit('showSecondMessage', this.showSecondMessage);
        this.$emit('isShowMessage', this.isShowMessage);
        this.$emit('immediatePayAmount', this.getImmediatePayAmount);
        this.$emit('paymentDueDate', this.paymentDueDate);
        this.$emit('isPastDueAndOnDirectBill', this.isPastDueAndOnDirectBill);

        // Start
        try {
          const i = this.$dynatrace.enterAction(
            `UpdateBillingMethod_${this.$t('L_monthly_bank_draft')?.replaceAll(
              ' ',
              '-'
            )}_ConfirmChange_selected`
          );
          this.$dynatrace.leaveAction(i);
        } catch (_error) {
          /* empty */
        }
        const paymentInfo = {
          type: 'METHOD',
          nextCycleDate: this.bankInfo.nextCycleDate,
          draftAmount: this.bankInfo.draftAmount?.replace(',', ''), // Remove comma
          reqMode: this.bankInfo.reqMode,
          draftDay: this.bankInfo.draftDay,
          emailAddress: this.customerProfile.email,
          language: this.locale,
          bankAccount: {
            accountName: this.bankInfo.accountName,
            routingNumber: this.bankInfo.routingNumber,
            accountNumber: this.bankInfo.accountNumber,
            accountType: this.bankInfo.accountType === 1 ? '3' : ' ',
          },
        };
        await this.updateBillingMode({
          paymentInfo,
          policyNumber: this.bankInfo.policyNumber,
        }).then(async (response: AxiosResponse | null) => {
          if (response) {
            // TODO
            // try {
            //   const i = this.$dynatrace.enterAction(`UpdateBillingMethod_${this.$t('L_monthly_bank_draft')?.replaceAll(' ', '-')}_ChangesSubmitted_Success`);
            //   this.$dynatrace.leaveAction(i);
            // } catch (error) { /*  */ }

            /*
             * Emit a custom action when a user successfully submits a bank/payment info change
             * https://www7.v1host.com/Primerica/attachment.img/284635/Analytics%20User%20Stories%20DT_3.30.21.docx
             */
            // TODO
            // const m = 'bank_info_changes_saved';
            // const i = this.$dynatrace.enterAction(m);
            // this.$dynatrace.leaveAction(i);

            // TODO see if following 2 is needed
            // this.$emit('goToStepThree', this.bankInfo);
            // this.showCompleteBanner();
            const currentContractId = this.policyData?.contractId;
            await this.refreshPolicies();
            // if (resStatus === 200) {
            await this.refreshPaymentData();
            // Find the index that has the same contractId and use it to set the policyData
            const index = this.policies.findIndex(
              (policy: IPolicyStorePolicy) => policy.contractId === currentContractId
            );
            await this.changePolicy({ selectedIndex: index });
            // } else {
            //   this.showErrorBanner();
            // }
          } else {
            this.showErrorBanner();
            try {
              const i = this.$dynatrace.enterAction(
                `UpdateBillingMethod_${this.$t('L_monthly_bank_draft')?.replaceAll(
                  ' ',
                  '-'
                )}_ChangesSubmitted_Failure_updateBillingModeError`
              );
              this.$dynatrace.leaveAction(i);
            } catch (_error) {
              /* empty */
            }
          }
          this.processCompleted = true;
        });
      } catch (_error) {
        /* empty */
      } finally {
        this.paymentInfoShowPaymentAmountDateBillingMethod = true;
      } // End
    },
    showErrorBanner() {
      this.globalStore.addError(
        {
          error: {
            key: 'L_your_request_cannot_be_processed_at_this_time',
            message: this.$t('L_your_request_cannot_be_processed_at_this_time'),
          },
          context: 'payment',
        },
        { root: true }
      );
    },
    cancelPayment() {
      this.$emit('cancel');
    },
    showDirectBillCards() {
      this.isDirectBillCardsDisplayed = true;
    },
  },
  async mounted() {
    this.processCompleted = true;
    this.accepted = false;
    await this.removeAlerts('payment');
  },
};

export default defineComponent(componentOptions);
</script>

<style scoped>
.payment-alert-list {
  list-style-type: disc;
  padding-left: 1.5rem;
}

.payment-alert-list li {
  display: list-item;
}
</style>

<style lang="scss" scoped>
.setMaxHeightCard {
  display: flex !important;
  flex-direction: column;
  height: 200px;
  flex: 0 1 auto;
  overflow-y: auto;
}

.bluebox {
  background: #f5f7fa;
}
</style>
